// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from './AuthContext';

// const ProtectedRoute = ({ children, allowedRoles }) => {
//   const { role } = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const logout = () => {
  
//       localStorage.clear();

//       navigate('/login');
//     };

//     if (!role) {
//       logout();
//     } else if (!allowedRoles.includes(role)) {
//       logout();
//     }
//   }, [role, allowedRoles, navigate]);

//   return allowedRoles.includes(role) ? children : null;
// };

// export default ProtectedRoute;

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { role, isLoading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoading) {
      console.log("Still loading, skipping auth check...");
      return;
    }

    const logout = () => {
      console.log("Logging out due to unauthorized access...");
      localStorage.clear();
      navigate('/');
    };

    if (!role) {
      console.log("Role not found, logging out...");
      logout();
    } else if (!allowedRoles.includes(role)) {
      console.log(`Role '${role}' not in allowedRoles:`, allowedRoles);
      logout();
    } else {
      console.log(`Access granted for role: ${role}`);
    }
  }, [role, allowedRoles, navigate, isLoading]);

  if (isLoading) {
    console.log("Rendering null (still loading)");
    return null;
  }

  return allowedRoles.includes(role) ? children : null;
};

export default ProtectedRoute;
